import React, { useEffect, useRef, useState } from 'react'
import {
    PiCaretDownFill,
    PiCaretUpFill,
    PiCheckCircleFill,
    PiWarningFill,
} from "react-icons/pi";
import { batchUploadFileBulk, cancelBulkDebitApi, cancelCampaignApi, debittingCountApi, faAppReport, getAllBulkDebitStatus, getAllPremiumCampaigns, getAllPremiumTemplates, getAllWorkflowMandates, getPremiumTransactionReport, mailReportApi, mailworkFlowReportApi, smsworkFlowReportApi, uploadPremiumNotificationApi, workFlowReportApi } from '../services';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router';
import ReactPaginate from 'react-paginate';
import LoadingModal from '../components/modals/LoadingModal';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { ModalBulkDebitModal } from '../components/modals/ModalBulkDebitNew';
import * as XLSX from "xlsx";
import { notify } from '../components/actions/CommonActions';
import { ModalCancelBulkDebit } from '../components/modals/ModalCancelBulkDebit';
import { ModalPremiumNotification } from '../components/modals/ModalPremiumNotification';
import { GoDownload } from 'react-icons/go';
import { ModalCancelPremiumNotification } from '../components/modals/ModalCancelPremiumNotification';

const PremiumNotification = () => {
    const [allMandates, setAllMandates] = useState([])
    const [allTemplates, setAllTemplates] = useState([])
    const [loading, setLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0); // For total pages
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [limit, setLimit] = useState(20)
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [batchId, setBatchId] = useState(null)
    const dropdownRef = useRef(null);
    const [mandateInfo, setMandateInfo] = useState(null)
    const navigate = useNavigate()
    const [modalUploadExcel, setModalUploadExcel] = useState(false)
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [uploadedFile, setUploadedFile] = useState(null)
    const [isUploaded, setIsUploaded] = useState(false)
    const [note, setNote] = useState("")
    const [name, setName] = useState("")
    const [channel, setChannel] = useState("")
    const [scheduleType, setScheduleType] = useState("")
    const [templateType, setTemplateType] = useState("")
    const [mandateData, setMandateData] = useState(null)
    const [showCancelModal, setShowCancelModal] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false);
    const [scheduleMins, setScheduleMins] = useState("")

    const WORKFLOWSTATUS = {
        BILLER_INITIATED: 1,
        BILLER_AUTHORISED: 2,
        BILLER_REJECTED: 3,
        BILLER_APPROVED: 4,
        BANK_AUTHORIZED: 6,
        BANK_REJECTED: 7,
        BANK_APPROVED: 8,
        BANK_DISAPPROVED: 9,
    };

    const handleExportHistory = async (id) => {
    setIsLoading(true)
      try {
        await getPremiumTransactionReport(id);
        setIsLoading(false)
      } catch (err) {
        console.log('Export error:', err);
        setIsLoading(false)
      }
    };

    const handleAllMandates = async (page, limit) => {
        const params = {
            limit: limit,
            page: page,
        }

        const searchParams = new URLSearchParams()
        // Add parameters only if they are defined and not empty
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });

        await getAllPremiumCampaigns(searchParams)
            .then((res) => {
                //   console.log("all premium campaigns res ", res?.data?.data);
                setAllMandates(res?.data?.data)
                setPageCount(res?.data?.totalPages)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                console.log('err ', err);
            })
    }

        const handleAllTemplates = async (page, limit) => {
        const params = {
            limit: limit,
            page: page,
        }

        const searchParams = new URLSearchParams()
        // Add parameters only if they are defined and not empty
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });

        await getAllPremiumTemplates(searchParams)
            .then((res) => {
                //   console.log("all premium campaigns res ", res?.data?.data);
                setAllTemplates(res?.data?.data)
                // setPageCount(res?.data?.totalPages)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                console.log('err ', err);
            })
    }

    const handlePageClick = async (data) => {
        setIsLoading(true);
        let selectedPage = data.selected + 1; // react-paginate uses 0-based index, so add 1
        setCurrentPage(selectedPage); // Update current page state
        await handleAllMandates(selectedPage, limit)
        setIsLoading(false);
    };


    useEffect(() => {
        const initiate = async () => {
            setLoading(true)
            await handleAllMandates(currentPage, limit) 
            await handleAllTemplates(1, 30)
            setLoading(false)
        }
        initiate()
    }, [])

    const toggleDropdown = (id, mandateCode, mandate) => {
        setOpenDropdownId(id);
        setBatchId(mandateCode)
        setMandateInfo(mandate)
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        // console.log("e. target ",e.target.files[0]);
        setUploadedFile(file)
    }

    const handleUploadFile = async () => {
        setModalUploadExcel(false)
        const file = uploadedFile

        const originalDate = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').toISOString();
        //   console.log("file ", file, note, originalDate);
        const formData = new FormData()
        formData.append('file', file)
        formData.append('description', note)
        formData.append('name', name)
        formData.append('channel', channel)
        formData.append('templateType', templateType)
        formData.append('scheduleType', scheduleType)
        if(scheduleType == "specific"){
        formData.append('scheduleDateTime', originalDate)
        }
        if(scheduleType == "later"){
        formData.append('scheduleMinutes', scheduleMins)
        }
        setIsLoading(true)
        await uploadPremiumNotificationApi(formData)
            .then(async (res) => {
                setIsLoading(false);
                //   console.log("all mandates to debit res ", res?.data);
                notify("success", "Mandate debit uploaded successfully.", `${res?.message}`);
                setLoading(true)
                await handleAllMandates(currentPage, limit)
                setLoading(false)
                //   navigate('/all-new-mandates')
            })
            .catch((err) => {
                setIsLoading(false);
                notify("danger", "OOPS", `${err?.response?.data?.message}`);
                console.log('err ', err);
            })
    }

    
        const handleCancelDebit = async (mandate) => {
            setIsDeleting(true)
            await cancelCampaignApi(mandate?.id)
                .then(async (res) => {
                    setAllMandates((prev) =>
  prev.map((each) =>
    each.sessionId === mandate?.id ? { ...each, status: "cancelled" } : each
  )
);
                    //   console.log("all transaction res ", res?.data);
                    // await setIsDeleting(false)
                    // await setHistory(res)
                    // setShowSingleDebitModal(false)
                    // setFaReport(res?.data)
                })
                .catch((err) => {
                    setIsDeleting(false)
                    notify("danger", "OOPS", `${err?.response?.data?.message}`);
                    // console.log('err ', err);
                })
        }

        const downloadCSV = () => {
  const header = 'contractId\n';
  const rows = mandateInfo?.mandateNotFound.join('\n');
  const csvContent = header + rows;

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'contract_ids.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

    return (
        <>
            {loading ? (
                <div className="typewriter-container">
                    <div class="typewriter">
                        <div class="slide">
                            <i></i>
                        </div>
                        <div class="paper"></div>
                        <div class="keyboard"></div>
                    </div>
                    <code style={{ color: "#000" }}>Getting your app ready...</code>
                </div>
            ) : (
                <div style={{ overflowX: "auto" }}>

                    {/* <form onSubmit={async(e)=> {
            e.preventDefault()
            setIsLoading(true);
            await handleAllMandates(1, 10)
            setIsLoading(false);
        }} style={{display: "flex", justifyContent: "flex-end", padding: "10px 0", gap: "10px"}}>
            <input type="text" onChange={(e)=> setSearch(e.target.value)} style={{border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none"}} />
            <button type="submit" style={{border: "none", backgroundColor: "#007dcc", color: "white", padding: "0px 10px", borderRadius: "5px"}}>Search</button>
        </form> */}
                    <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px 0" }}>
                        <button type="button" onClick={() => setModalUploadExcel(true)} style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "10px 10px", borderRadius: "5px", marginleft: "10px", marginRight: "10px" }}>Upload Excel</button>
                        {/* <button type="button" onClick={handleExportHistory} style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "4px 10px", borderRadius: "5px", marginLeft: "10px" }}><GoDownload color="white" />Export</button> */}
                    </div>
                    {/* <h5 className='mt-3'>Sms Report</h5> */}
                    <table className="fl-table">
                        <thead>
                            <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                                {/* Table header cells */}
                                {/* Modify according to your data structure */}
                                <th width="20%">Name</th>
                                <th width="20%">Description</th>
                                <th width="20%">Message template</th>
                                <th width="20%">Channel</th>
                                <th width="20%">Uploaded file</th>
                                <th>Status</th>
                                <th>Record</th>
                                {/* <th>Total Records</th>
                                <th>Processed Records</th>
                                <th>Successful Records</th>
                                <th>Failed Records</th> */}
                                <th>Scheduled at</th>
                                <th>Started at</th>
                                <th>Completed At</th>
                                <th>Created At</th>
                                <th>...</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                allMandates?.map((mandate) => (
                                    <tr
                                        className="tr"
                                        key={mandate.id}
                                    >
                                        <td className="gray-td">{mandate?.name}</td>
                                        <td className="gray-td">{mandate?.description}</td>
                                        <td className="gray-td">{mandate?.messageTemplate}</td>
                                        <td className="gray-td">{mandate?.channel}</td>
                                        <td className="gray-td">{mandate?.uploadedFileName}</td>
                                        <td className="gray-td">{mandate?.status}</td>
                                        <td>
                                        <div style={{borderBottom: "1px solid gray", display: "flex", justifyContent: "space-between", alignItems: "center", width: "200px", padding: "5px 0"}}>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "gold"}}>Processed Count:</p>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "gold"}}>{mandate?.processedCount}</p>
                                            </div><div style={{borderBottom: "1px solid gray", display: "flex", justifyContent: "space-between", alignItems: "center", width: "200px", padding: "5px 0"}}>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "green"}}>Successful Count:</p>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "green"}}>{mandate?.successCount}</p>
                                            </div><div style={{borderBottom: "1px solid gray", display: "flex", justifyContent: "space-between", alignItems: "center", width: "200px", padding: "5px 0"}}>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "red"}}>Failed Count:</p>
                                                <p style={{marginBottom: "0px", fontWeight: "500", color: "red"}}>{mandate?.failedCount}</p>
                                            </div>
                                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "200px", padding: "5px 0"}}>
                                                <p style={{marginBottom: "0px", fontWeight: "500"}}>Total Recipients:</p>
                                                <p style={{marginBottom: "0px", fontWeight: "500"}}>{mandate?.totalRecipients}</p>
                                            </div>
                                        </td>
                                        {/* <td className="gray-td">{mandate?.totalRecords}</td>
                                        <td className="gray-td">{mandate?.processedRecords}</td>
                                        <td className="gray-td">{mandate?.successfulRecords}</td>
                                        <td className="gray-td">{mandate?.failedRecords}</td> */}
                                        <td className="gray-td">
  {mandate?.scheduledAt && moment(mandate?.scheduledAt).format('DD MMM, YYYY')} &nbsp; &nbsp; {mandate?.scheduledAt && moment(mandate?.scheduledAt).format('hh:mm A')}
</td>
                                        <td className="gray-td">
  {mandate?.startedAt && moment(mandate?.startedAt).format('DD MMM, YYYY')} &nbsp; &nbsp; {mandate?.startedAt && moment(mandate?.startedAt).format('hh:mm A')}
</td>
                                        <td className="gray-td">
  {mandate?.completedAt && moment(mandate?.completedAt).format('DD MMM, YYYY')} &nbsp; &nbsp; {mandate?.completedAt && moment(mandate?.completedAt).format('hh:mm A')}
</td>
                                        <td className="gray-td">{moment(mandate?.createdAt).format('DD MMM, YYYY')}</td>
                                        <td style={{ textAlign: "center" }} >
                                            <div className="relative" style={{ position: "relative" }}>
                                                <button
                                                    onClick={() => toggleDropdown(mandate?.id, mandate?.id, mandate)}
                                                    className="dotsBtn"
                                                >
                                                    <HiOutlineDotsVertical />
                                                </button>

                                                {openDropdownId === mandate?.id && (
                                                    <div className="dropdownSelect" ref={dropdownRef} style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.15)', zIndex: 100, backgroundColor: "white" }}>
                                                        
                                                        <div className="updateBtn">
                                                        <button
                                                                onClick={async () => {
                                                                    await handleExportHistory(mandate?.id)
                                                                    // await handleCancelDebit(mandate)
                                                                }}
                                                                style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                                                            >
                                                                Download report
                                                            </button>
                                                        </div>
                                                        <div className="updateBtn">
                                                            <button
                                                                onClick={async () => {
                                                                    setMandateData(mandate)
                                                                    setShowCancelModal(true)
                                                                    // await handleCancelDebit(mandate)
                                                                }}
                                                                style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                                                            >
                                                                Cancel Notification
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount} // Total pages from API
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={currentPage - 1}
                    />
                    <LoadingModal show={isLoading} />
                    <ModalPremiumNotification
                        show={modalUploadExcel}
                        toggle={() => setModalUploadExcel(!modalUploadExcel)}
                        date={date}
                        time={time}
                        setDate={setDate}
                        setTime={setTime}
                        handleFileChange={handleFileChange}
                        handleUploadFile={handleUploadFile}
                        note={note}
                        setNote={setNote}
                        setName={setName}
                        setChannel={setChannel}
                        setScheduleType={setScheduleType}
                        allTemplates={allTemplates}
                        setScheduleMins={setScheduleMins}
                        setTemplateType={setTemplateType}
                        scheduleType={scheduleType}
                    />
                    <ModalCancelPremiumNotification show={showCancelModal} toggle={()=> setShowCancelModal(false)} handleDeleteMandate={ () => handleCancelDebit(mandateData)} mandate={mandateData} isDeleting={isDeleting} />
                </div>
            )}
        </>
    )
}

export default PremiumNotification